import { opr } from "@opera-gx/browser-api";
import { derived, readable } from "svelte/store";

import { browser } from "$app/environment";

import { isAndroid } from "../env";

const gxPaletteConfig = readable({}, (set) => {
  if (!browser) {
    return;
  }

  if (window?.oprt?.gxCornerConfig?.colors && isAndroid) {
    return;
  }

  const handler = () => {
    opr?.palette?.getPalette().then(set);
  };

  handler();

  window.addEventListener("onconfigchange", handler);
  opr?.palette?.addListener(handler);

  return () => {
    opr?.palette.removeListener(handler);
    window.removeEventListener("onconfigchange", handler);
  };
});

export const paletteConfig = derived([gxPaletteConfig], ([$palette]) => $palette || {});
